export const Button = props => {
    return (
      <button className="button" id={props.name} onClick={props.name === "info" ? () => props.handleClick() : ""}>
        {props.text}
      </button>
    )
  }